import { Component, OnInit } from '@angular/core';
import { AbstractGrundstueckEntryFromRoute } from '../abstract-grundstueck-entry-from.route';
import { FieldMetaData, GbgrundstueckService, GrundstueckId } from 'app/core/gb-api';
import { TimepointService } from 'app/core/services/timepoint.service';
import { AppConfigService } from 'app/core/services/app-config.service';
import { AmtlichebewertungNeskoService, NeskoAbDetailEntryMeta } from 'app/core/amtlichebewertung-api';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { keysToTranslate } from 'i18n/keys-to-translate';
import { NavTarget } from 'app/shared/components/link/link.component';
import { ActivatedRoute, Router } from '@angular/router';
import { NeskoAmtlicheBewertungComponent } from '../../../neskoab/neskoab-detail/nesko-amtliche-bewertung/nesko-amtliche-bewertung.component';
import { ObjekteComponent } from '../../../neskoab/neskoab-detail/objekte/objekte.component';
import { RubrikComponent } from '../../../shared/components/rubrik/rubrik.component';
import { NeskoabGrundstueckEigentumComponent } from '../../../neskoab/neskoab-detail/neskoab-grundstueck-eigentum/neskoab-grundstueck-eigentum.component';
import { NeskoabPersonenEigentumComponent } from '../../../neskoab/neskoab-detail/neskoab-personen-eigentum/neskoab-personen-eigentum.component';
import { NeskoabNutzniesserComponent } from '../../../neskoab/neskoab-detail/neskoab-nutzniesser/neskoab-nutzniesser.component';
import { CapAlertComponent } from '../../../core/extension/exceptions/cap-alert.component';

@Component({
  selector: 'cap-neskoab-rubrik',
  templateUrl: './neskoab-rubrik.component.html',
  styleUrls: ['./neskoab-rubrik.component.scss'],
  imports: [
    NeskoAmtlicheBewertungComponent,
    ObjekteComponent,
    RubrikComponent,
    NeskoabGrundstueckEigentumComponent,
    NeskoabPersonenEigentumComponent,
    NeskoabNutzniesserComponent,
    CapAlertComponent,
    TranslatePipe
  ]
})
export class GrundstueckNeskoabRubrikComponent extends AbstractGrundstueckEntryFromRoute implements OnInit {
  navTargets = NavTarget;

  neskoEntry: NeskoAbDetailEntryMeta;

  _gsId: GrundstueckId;

  neskoServiceVerfuegbar = true;

  constructor(
    protected route: ActivatedRoute,
    protected grundstueckService: GbgrundstueckService,
    protected timepointService: TimepointService,
    protected appConfigService: AppConfigService,
    protected router: Router,
    private neskoAbService: AmtlichebewertungNeskoService,
    private translate: TranslateService
  ) {
    super(route, grundstueckService, timepointService, appConfigService, router);
    keysToTranslate<string>(['neskoab.Eigentum/Verteiler']);
  }

  ngOnInit() {
    super.ngOnInit();
    this.addSub(
      this.translate.onLangChange.subscribe(() => {
        this.loadData();
      })
    );
  }

  loadData() {
    this.neskoServiceVerfuegbar = true;
    if (!this.gsId) {
      return;
    }
    this.addSub(
      this.neskoAbService
        .loadSichtByGrundstueckNummer(
          null, //
          null, //
          null, //
          null, //
          this.gsId.id, //
          this.translate.currentLang
        )
        .subscribe({
          next: (entry) => {
            this.neskoEntry = entry;
          },
          error: (err) => {
            if (err.status === 502) {
              this.neskoServiceVerfuegbar = false;
              return;
            } else if (err.status === 404) {
              return;
            }
            throw err;
          }
        })
    );
  }

  get gsNummer(): string {
    let nummer = this.neskoEntry.nummer;
    if (this.neskoEntry.nummer2 !== '0' || this.neskoEntry.nummer3 !== '0') {
      nummer += '-' + this.neskoEntry.nummer2;
    }
    if (this.neskoEntry.nummer3 !== '0') {
      nummer += '-' + this.neskoEntry.nummer3;
    }
    return nummer;
  }

  get hasRightObjekte(): boolean {
    if (this.neskoEntry) {
      return this.neskoEntry.mObjekte.access !== FieldMetaData.AccessEnum.NONE;
    }
    return false;
  }

  get hasRightVerteiler(): boolean {
    if (this.neskoEntry) {
      return this.neskoEntry.mVerteiler.access !== FieldMetaData.AccessEnum.NONE;
    }
    return false;
  }

  get hasRightNutzniessung(): boolean {
    if (this.neskoEntry) {
      return this.neskoEntry.mNutzniesser.access !== FieldMetaData.AccessEnum.NONE;
    }
    return false;
  }

  get hasRightAmtlicherWert(): boolean {
    if (this.neskoEntry) {
      return this.neskoEntry.mAmtlicherWert.access !== FieldMetaData.AccessEnum.NONE;
    }
    return false;
  }

  get hasRightEigentum(): boolean {
    if (this.neskoEntry) {
      return this.neskoEntry.mEigentum.access !== FieldMetaData.AccessEnum.NONE;
    }
    return false;
  }
}
